import { unsafeCSS } from 'lit-element';
import resetImport from '../../../css/reset.css';

export const reset = unsafeCSS(resetImport);
